import initialState from '../../initialState';
import { ExampleGalleryActions } from '../../constants';

const reducer = (state = initialState.ExampleGallery, action = {}) => {
  switch (action.type) {
    case ExampleGalleryActions.SET_IS_OPEN:
      return { ...state, isOpen: action.isOpen };
    case ExampleGalleryActions.SET_EXAMPLE_ID:
      return { ...state, exampleId: action.exampleId };
    case ExampleGalleryActions.SET_EXAMPLE:
      return {
        ...state,
        dossierUrl: action.dossierUrl,
        exampleGroupName: action.exampleGroupName,
        exampleName: action.exampleName,
        exampleId: action.exampleId,
        exampleDesc: action.exampleDesc,
        embeddingType: action.embeddingType,
        image: action.image,
      };
    default:
      return state;
  }
};
export default reducer;
